import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { useAuthStore } from "./auth.store";
import apiOrganizationClient from "../api/api.organization";
import { enqueueSnackbar } from "notistack";
import { throwError } from "../hooks/useErrorHandler";
import { TicketsStore } from "../types/Store/TicketsStore.types";

export const useTicketsStore = create<TicketsStore>()(
    persist(
        (set, get) => ({
            async getTickets(offset = 0, order = "DESC") {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    const { data, status } = await apiOrganizationClient.get(
                        "/api/v1/ticket/ticket?personal_account_id=" +
                            activeAccount +
                            "&offset=" +
                            offset * 10 + "&sort_order=" + order,
                    );

                    if ((status == 200 || status == 201 || status == 204) && data)
                        return [data.tickets || [], data.total_count || 0];
                    else return [[], 0];
                } catch (error) {
                    throwError(error);
                    return [[], 0];
                }
            },

            async createTicket(title, description, image) {
                try {
                    const { activeAccount } = useAuthStore.getState();
                    if (image) {
                        const fd = new FormData();
                        fd.append("file", image);
                        const { status } = await apiOrganizationClient.post(
                            "/api/v1/ticket/ticket/photo?personal_account_id=" +
                                activeAccount +
                                "&title=" +
                                title +
                                "&description=" +
                                description,
                            fd,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                                onUploadProgress: (e) => {
                                    if (e.total) {
                                        const percent = Math.round(
                                            (e.loaded * 100) / e.total,
                                        );
                                        console.log(
                                            `Загружено feedback: ${percent}%`,
                                        );
                                    }
                                },
                            },
                        );

                        if (status == 200 || status == 201 || status == 204) {
                            enqueueSnackbar("Заявка успешно создана", {
                                variant: "success",
                            });
                        }
                    } else {
                        const { status } = await apiOrganizationClient.post(
                            "/api/v1/ticket/ticket",
                            {
                                title,
                                description,
                                personal_account_id: activeAccount,
                            },
                        );

                        if (status == 200 || status == 201 || status == 204) {
                            enqueueSnackbar("Заявка успешно создана", {
                                variant: "success",
                            });
                        }
                    }
                } catch (error) {
                    throwError(error);
                }
            },

            async getTicketById(id) {
                try {
                    const { data, status } = await apiOrganizationClient.get(
                        "/api/v1/ticket/ticket/" + id,
                    );

                    if (status == 200 || status == 201 || status == 204)
                        return data;
                    else return null;
                } catch (error) {
                    throwError(error);
                }
            },

            async sendRating(ticket_id, rate) {
                try {
                    const {activeAccount} = useAuthStore.getState()
                    const {status} = await apiOrganizationClient.post(
                        "/api/v1/ticket/ticket/rate",
                        {
                            ticket_id,
                            rating: rate,
                            personal_account_id: activeAccount
                        }
                    )

                    if(status == 200 || status == 201 || status == 204){
                        enqueueSnackbar("Рейтинг успешно отправлен", {
                            variant: "success",
                        });
                    }
                } catch (error) {
                    throwError(error)
                }
            }
        }),
        {
            name: "tickets-store", // ключ в localStorage
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({}),
        },
    ),
);
